import { Icon } from './Icon';

/** Склад: коробка в изометрии. */
export function BoxIcon({ size = 20 }: { size?: number }) {
  return (
    <Icon size={size} box={20}>
      <path d="M3 6.4 L10 3 L17 6.4 V14 L10 17.4 L3 14 Z" />
      <path d="M3 6.4 L10 9.8 L17 6.4" />
      <path d="M10 9.8 V17.4" />
    </Icon>
  );
}
